export const VN = 0;
export const EN = 1;

export const ENV = 1;
export const MEKONG = 2;
export const HERITAGE = 3;

export const Lang = Object.freeze({
    VN: 0,
    EN: 1
});

export const Group = Object.freeze({
    ENV: 1,
    MEKONG: 2,
    HERITAGE: 3
});

export const SearchOn = Object.freeze({
    NONE: 0,
    TITLE: 1,
    CONTENT: 2,
    AUTHOR: 3,
});
